import { render, staticRenderFns } from "./VaIconVuestic.vue?vue&type=template&id=1d9da016&scoped=true&"
import script from "./VaIconVuestic.vue?vue&type=script&lang=js&"
export * from "./VaIconVuestic.vue?vue&type=script&lang=js&"
import style0 from "./VaIconVuestic.vue?vue&type=style&index=0&id=1d9da016&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d9da016",
  null
  
)

export default component.exports